<template>
  <div class="wincard-body">
    <WinCard
      title="For Brands"
      text="We provide a platform where brands can efficiently manage their inventory, reducing the burden of unsold goods. By leveraging Wecobi's innovative strategies, brands can convert excess inventory into valuable revenue streams and marketing opportunities, all while maintaining their brand integrity and profitability."
      :imageUrl="WinBrandImage"
    />
    <WinCard
      title="For Consumers"
      text="Wecobi offers consumers access to exclusive, high-quality products at discounted prices. Our platform fosters a sense of community and engagement, allowing customers to feel more connected to the brands they love. This not only enhances the shopping experience but also encourages responsible consumption, as customers are more likely to value and cherish the products they purchase."
      :imageUrl="WinConsumersImage"
    />
    <WinCard
      title="For the Environment"
      text="Our model is inherently sustainable. By keeping products in circulation longer, we significantly reduce waste and minimize the environmental impact associated with traditional retail practices. Whether it's preventing items from ending up in landfills or reducing the carbon footprint of production, Wecobi's approach ensures that every transaction contributes positively to the planet."
      :imageUrl="WinEnvironmentImage"
    />
  </div>
</template>

<script>
import WinCard from "./ReusableComponents/WinCard.vue";
import WinBrandImage from "../../../assets/sustainability/winSection/winbrand.png";
import WinConsumersImage from "../../../assets/sustainability/winSection/winconsumers.png";
import WinEnvironmentImage from "../../../assets/sustainability/winSection/winenvironment.png";

export default {
  name: "WinForAll",
  components: {
    WinCard,
  },
  data() {
    return {
      WinBrandImage: WinBrandImage,
      WinConsumersImage: WinConsumersImage,
      WinEnvironmentImage: WinEnvironmentImage,
    };
  },
};
</script>

<style scoped>
.wincard-body {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}
@media (max-width: 880px) {
  .wincard-body {
    flex-direction: column;
  }
}
</style>
